let AnnotationUtil = require("../util/AnnotationUtil");

class TimelineAnnotations extends React.Component {
  componentDidMount() {
    this.updateChart(this.props, this.state);
  }

  shouldComponentUpdate(nextProps, nextState) {
    this.updateChart(nextProps, nextState);

    return true;
  }

  updateChart(props, state) {
    let rootNode = d3.select(ReactDOM.findDOMNode(this));

    let scale = props.scale;
    let rects = rootNode.select("g").selectAll("rect").data(props.data, function (d, i) {
      return d.id;
    });

    rects
      .enter()
      .append("rect");

    rects
      .attr("data-type", function (d, i) {
        return d.event.type;
      })
      .attr("x", function (d, i) {
        return scale(d.startTs);
      })
      .attr("y", function (d, i) {
        return props.height / 4;
      })
      .attr("width", function (d, i) {
        return Math.max(2, scale(d.stopTs) - scale(d.startTs));
      })
      .attr("height", props.height / 2)
      .attr("data-tooltip", function (d, i) {
        return AnnotationUtil.getDescription(d);
      })
      .on("mouseover", function (d, i) {
        if (d.event && ["activity", "diary"].includes(d.event.type)) {
          let getAnno = () => {
            let url = `/studies/${d.studyId}/annotations/${d.id}/questions`;

            mc.ajax.get(url).then((response) => {
              let questions = mc.ajax.parse(response).items;

              if (questions.length) {
                let title = AnnotationUtil.getDescription(d);
                let text = questions.map((q) => q.question + ": " + q.answer).join("; ");

                props.onDetail({ title, text });
              }
            });
          };

          this.timeout = setTimeout(getAnno, 250);
        }
      })
      .on("mouseout", function (d, i) {
        clearTimeout(this.timeout);

        props.onDetail(null);
      });

    rects
      .exit()
      .remove();
  }

  render() {
    let { width, height } = this.props;

    return (
      <g>
        <rect x="0" y="0" width={width} height={height} fill="#f1f1f1"/>
        <g className="rc-timeline-annotations"/>
      </g>
    );
  }
}

TimelineAnnotations.defaultProps = {
  height: 40
};

module.exports = TimelineAnnotations;